import { inject, Service } from '@angular/core';
import { ConfigService } from '@ngx-config/core';
import { Store } from '@ngxs/store';
import { SetConfig } from './config.state';
import { EnvironmentInformation, ServiceConfig } from './config.types';

@Service()
export class MngConfigService {
  private readonly configService = inject(ConfigService);

  constructor() {
    const store = inject(Store);

    const config = this.getConfig();
    store.dispatch(new SetConfig(config));
  }

  getConfig<T = any>(): EnvironmentInformation<T> {
    return this.configService.getSettings<EnvironmentInformation<T>>();
  }

  getAppProperties<T = any>(): T {
    return this.configService.getSettings<T>('clientProps');
  }

  getSystemProperties(): ServiceConfig {
    return this.configService.getSettings<ServiceConfig>('service');
  }
}
